"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCardRegistrationOptions = void 0;
class CreateCardRegistrationOptions {
    mangopayId;
    userId;
}
exports.CreateCardRegistrationOptions = CreateCardRegistrationOptions;
//# sourceMappingURL=CreateCardRegistrationOptions.js.map